let SQLite = null
try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { Platform } = require('react-native')
    if (Platform?.OS !== 'web') {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        SQLite = require('expo-sqlite')
    }
} catch {}
import { isWeb, getPlatform } from '../src/utils/platformUtils'
let __dbModule = null
const buildLocalWrappedDb = () => {
    if (globalThis.__DOTS_SQLITE_WRAPPED_DB) {
        return globalThis.__DOTS_SQLITE_WRAPPED_DB
    }
    try {
    if (!SQLite) throw new Error('SQLite not available (web stub)')
    const localDb = SQLite.openDatabaseSync('myDB')
        if (getPlatform().OS === 'android') {
            try { localDb.execSync('PRAGMA journal_mode = WAL;') } catch {}
        }
        const wrapStatement = (stmt) => ({
            executeSync: (params = []) => {
                const res = stmt.executeSync(params)
                const rowsArray = Array.isArray(res?.rows) ? res.rows : Array.isArray(res?.rows?._array) ? res.rows._array : []
                return {
                    ...res,
                    getAllSync: () => rowsArray,
                    getFirstSync: () => (rowsArray && rowsArray.length ? rowsArray[0] : null),
                }
            },
            finalizeSync: () => stmt.finalizeSync(),
        })
        const wrapped = {
            execSync: (sql) => localDb.execSync(sql),
            prepareSync: (sql) => {
                const stmt = localDb.prepareSync(sql)
                const wrapped = wrapStatement(stmt)
                return {
                    executeSync: wrapped.executeSync,
                    finalizeSync: wrapped.finalizeSync,
                    getAllSync: (params = []) => wrapped.executeSync(params).getAllSync(),
                    getFirstSync: (params = []) => wrapped.executeSync(params).getFirstSync(),
                }
            },
        }
        globalThis.__DOTS_SQLITE_WRAPPED_DB = wrapped
        return wrapped
    } catch (e) {
        console.error('Fallback SQLite wrapper (tracking) failed:', e)
        return null
    }
}
const getWrappedDB = () => {
    if (!__dbModule) {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        __dbModule = require('../src/db/indexDB')
    }
    const fromIndex = __dbModule?.getNativeDB ? __dbModule.getNativeDB() : null
    return fromIndex || buildLocalWrappedDb()
}
import { PORTFOLIO_STORE_NAMES } from '../src/db/constants'
export const TRACKINGS = {
    TRACKINGS: 'trackings',
}

const database = 'myDB'

const openDatabase = () => {
    if (isWeb()) {
        // Web usa IndexedDB directamente en los métodos; devolvemos stub seguro
        return { transaction: () => ({ executeSql: () => {} }) }
    }

    const dbSync = getWrappedDB()
    const facade = {
        execSync: (sql) => dbSync.execSync(sql),
        prepareSync: (sql) => dbSync.prepareSync(sql),
        transaction: (callback, errorCallback, successCallback) => {
            try {
                const tx = {
                    executeSql: (sql, params = [], success, error) => {
                        try {
                            const isSelect = /^\s*SELECT/i.test(sql)
                            if (isSelect) {
                                const stmt = dbSync.prepareSync(sql)
                                const rowsArray = stmt.getAllSync(params)
                                stmt.finalizeSync()
                                const rows = {
                                    length: rowsArray.length,
                                    item: (i) => rowsArray[i],
                                    _array: rowsArray,
                                }
                                const result = { rows, rowsAffected: 0, insertId: undefined }
                                success && success(tx, result)
                            } else {
                                const stmt = dbSync.prepareSync(sql)
                                stmt.executeSync(params)
                                stmt.finalizeSync()
                                const changes = dbSync.prepareSync('SELECT changes() as rowsAffected').getFirstSync()
                                const lastId = /\bINSERT\b/i.test(sql)
                                    ? dbSync.prepareSync('SELECT last_insert_rowid() as insertId').getFirstSync()
                                    : { insertId: undefined }
                                const result = {
                                    rows: { length: 0, item: () => undefined, _array: [] },
                                    rowsAffected: changes?.rowsAffected ?? 0,
                                    insertId: lastId?.insertId,
                                }
                                success && success(tx, result)
                            }
                        } catch (e) {
                            if (error) return error(tx, e)
                            throw e
                        }
                    },
                }
                callback && callback(tx)
                successCallback && successCallback()
            } catch (e) {
                errorCallback && errorCallback(e)
            }
        },
    }

    return facade
}

export const db = openDatabase()

class trackingServices {
    constructor() {
        this.db = db
    }

    addTracking = async (interaction_id, type_interaction, table) => {
        if (interaction_id == null) {
            return //cuando llega null
        } else {
            return new Promise(async (resolve, reject) => {
                if (isWeb()) {
                    try {
                        // Obtener la instancia real de IndexedDB
                        if (!__dbModule) {
                            __dbModule = require('../src/db/indexDB')
                        }
                        const dbInstance = await __dbModule.openDB()
                        
                        const transaction = dbInstance.transaction([TRACKINGS.TRACKINGS], 'readwrite')
                        const objectStore = transaction.objectStore(TRACKINGS.TRACKINGS)

                        const request = objectStore.add({
                            content_id: interaction_id,
                            date_interaction_init: new Date().toISOString(),
                            type_interaction: type_interaction,
                            name_table: table,
                        })

                        request.onsuccess = () => {
                            resolve()
                        }

                        request.onerror = (event) => {
                            reject(event.target.error)
                        }
                    } catch (error) {
                        console.error('[addTracking][web] Error:', error)
                        reject(error)
                    }
                } else {
                    db.transaction(
                        (tx) => {
                            let insert_tracking = [interaction_id, new Date().toISOString(), type_interaction, table]
                            tx.executeSql(
                                `INSERT INTO ${TRACKINGS.TRACKINGS} (
                                                content_id,
                                                date_interaction_init,
                                                type_interaction,
                                                name_table
                                                
                                            ) VALUES (?, ?, ?, ? );`,
                                insert_tracking,
                                (_, result) => {
                                    //  console.log('🚀 ~ guardo el tracking')
                                    resolve()
                                },
                                (_, error) => {
                                    console.error('Transaction  insert error:', error)
                                    reject(error)
                                },
                            )
                        },
                        (error) => {
                            console.error('Transaction addTracking error:', error)
                            reject(error)
                        },
                        (_, success) => {
                            resolve()
                        },
                    )
                }
            })
        }
    }

    getTrackings = () => {
        return new Promise((resolve, reject) => {
            if (isWeb()) {
                const transaction = db.transaction([TRACKINGS.TRACKINGS], 'readonly')
                const objectStore = transaction.objectStore(TRACKINGS.TRACKINGS)

                const request = objectStore.getAll()
                request.onsuccess = (event) => {
                    const trackings = event.target.result
                    resolve(trackings)
                }

                request.onerror = (event) => {
                    reject(event.target.error)
                }
            } else {
                db.transaction(
                    (tx) => {
                        tx.executeSql(
                            `SELECT * FROM ${TRACKINGS.TRACKINGS}`,
                            [],
                            (_, result) => {
                                if (result.rows.length > 0) {
                                    let trackings = []
                                    for (let i = 0; i < result.rows.length; i++) {
                                        trackings.push(result.rows.item(i))
                                    }
                                    //  console.log("trackings", trackings.length)
                                    // console.log("trackings", trackings)

                                    resolve(trackings)
                                } else {
                                    resolve([])
                                }
                            },
                            (_, error) => {
                                console.error('Error al obtener los trackings:', error)
                                reject(error)
                            },
                        )
                    },
                    (error) => {
                        console.error('Transaction getTrackings error:', error)
                        reject(error)
                    },
                )
            }
        })
    }

    deleteTrackingsFromLocal = () => {
        return new Promise((resolve, reject) => {
            const tableTrackings = TRACKINGS.TRACKINGS

            if (isWeb()) {
                const transaction = db.transaction([tableTrackings], 'readwrite')
                const objectStore = transaction.objectStore(tableTrackings)
                const request = objectStore.delete()

                request.onsuccess = () => {
                    resolve()
                }

                request.onerror = (event) => {
                    reject(event.target.error)
                }
            } else {
                db.transaction(
                    (tx) => {
                        tx.executeSql(
                            `DELETE FROM ${tableTrackings};`,
                            [],
                            (_, result) => {
                                console.log('Post eliminados del local con exito.')
                                resolve()
                            },
                            (_, error) => {
                                console.error('Error en la transacción deleteTrackingsFromLocal:', error)
                                reject(error)
                            },
                        )
                    },
                    (error) => {
                        console.error('Error en la transacción deleteTrackingsFromLocal - sqlite:', error)
                        reject(error)
                    },
                    null,
                )
            }
        })
    }

    deleteTrackingByIdFromLocal = (trackingId) => {
        return new Promise((resolve, reject) => {
            const tableTackings = TRACKINGS.TRACKINGS

            if (isWeb()) {
                const transaction = db.transaction([tableTackings], 'readwrite')
                const objectStore = transaction.objectStore(tableTackings)
                const request = objectStore.delete(trackingId)

                request.onsuccess = () => {
                    resolve()
                }

                request.onerror = (event) => {
                    reject(event.target.error)
                }
            } else {
                db.transaction(
                    (tx) => {
                        tx.executeSql(
                            `DELETE FROM ${tableTackings} WHERE _id = ?;`,
                            [trackingId],
                            (_, result) => {
                                //    console.log('Tracking eliminado del local con exito.')
                                resolve()
                            },
                            (_, error) => {
                                console.error('Error en la transacción deleteTrackingByIdFromLocal:', error)
                                reject(error)
                            },
                        )
                    },
                    (error) => {
                        console.error('Error en la transacción deleteTrackingByIdFromLocal - sqlite:', error)
                        reject(error)
                    },
                    null,
                )
            }
        })
    }
}

export const TrackingServices = new trackingServices(db)
